<template>
  <div id="projects">
    <div class="container">
      <div class="title">Proyectos</div>
      <div class="d-flex justify-content-around">
        <div class="row row-cols-1 row-cols-md-2">
          <div class="col mb-4">
            <div class="rectangle">
              <img
                src="@/assets/logo-consulmed.png"
                class="card-img-custom"
                alt="..."
                height="60"
                width="245"
              />
              <div class="card-body">
                <p class="card-title">
                  Sistema de autogestión de citas médicas, directorio de médicos
                  especialistas y pago en línea.
                </p>
                <a
                  href="https://www.consulmed.com.ve"
                  class="btn btn-outline-secondary bottom"
                  target="_blank"
                  >Ir a la Web</a
                >
              </div>
            </div>
          </div>
          <div class="col mb-4">
            <div class="rectangle">
              <img
                src="@/assets/logo-passer.png"
                class="card-img-custom"
                alt="..."
                height="60"
                width="245"
              />
              <div class="card-body">
                <p class="card-title">
                  Sistema de gestión de visitantes en línea para Clubs,
                  Condominios y empresas.
                </p>
                <a
                  href="https://www.passer.com.ve"
                  class="btn btn-outline-secondary bottom"
                  target="_blank"
                  >Ir a la Web</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
};
</script>
<style scoped>
#projects {
  background-color: #ebf5ee;
}
.title {
  padding-top: 20px;
  margin-bottom: 40px;
  font-size: 36px;
  font-weight: bold;
}
.rectangle {
  padding-top: 10px;
  z-index: 6;
  max-width: 540px;
  height: 320px;
  color: #a3a39e;
  box-shadow: 0px 10px 10px 5px rgba(100, 100, 100, 0.5);
  background-color: white;
}
.card-img-custom {
  align-self: center;
  margin-top: 20px;
  margin-bottom: 30px;
}
.card-body {
  height: 200px;
}
.card-title {
  height: 80px;
  font-size: 18px;
}
.btn {
  color: #a3a39e;
  border: 3px solid;
  line-height: 2em;
  border-radius: 0.5em;
}
.btn:hover {
  background-color: #a3a39e;
  border: 3px solid #a3a39e;
  color: white;
}
</style>
